export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/2tUiHb4Y7A4f4hvoLEU65Q/MOCKUP_HIRFR.png'
